import * as actionType from '../actionTypes';

const initialState = {
    downloadsException: '',
    downloadsJSON: ''
}
const downloads = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.DOWNLOADS_EXCEPTION:
            return {
                ...state,
                downloadsException: action.data
            };
        case actionType.DOWNLOADS_JSON:
            return {
                ...state,
                downloadsJSON: action.data
            };
        case actionType.DOWNLOADS_CLEAR:
            return {};
        default:
            return state
    }
}
export default downloads;